"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMultiSuggest = getMultiSuggest;
var _ramda = require("ramda");
var _ymaps = require("./ymaps");
var _yandexMonitor = require("./yandexMonitor");
/* eslint-disable  @typescript-eslint/no-explicit-any */
/* eslint-disable  no-useless-catch */

async function getMultiSuggest(params) {
  const {
    yandex: {
      value,
      apiKey,
      suggestApiKey
    }
  } = params;
  let yaSuggestResult = null;
  const suggestions = {};
  const yandexSuggestApi = await (0, _ymaps.loadYmapsApi)({
    require: ['suggest']
  }, apiKey, suggestApiKey);
  try {
    yaSuggestResult = await yandexSuggestApi.suggest(`Россия, ${value}`);

    /** Ошибку можно поймать, отрубив интернет */
    if ('message' in yaSuggestResult) {
      throw new _yandexMonitor.YandexScriptError();
    }
  } catch (e) {
    throw e;
  }
  if (!(0, _ramda.isEmpty)(yaSuggestResult)) {
    suggestions.addresses = yaSuggestResult;
  }
  return {
    suggestions,
    sortOrder: ['addresses']
  };
}